import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const ClientTransactionUpdateModal2UI = ({context, successMsg, errorList, setErrorList,
    updateMode, submitted, onSubmit, onCancelClick,
    category, onCategoryChange, categoryError, setCategoryError,
    isCredit, categoryMappedValueCreditList, categoryMappedValueDebitList
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Set category'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectUI name='category' value={category} required={true} label='Category'
      onChange={onCategoryChange} error={categoryError}
      optionList={isCredit ? categoryMappedValueCreditList : categoryMappedValueDebitList}
    />
  </ModalFormUI>

export default ClientTransactionUpdateModal2UI
